import { useCallback } from "react";
import { useFlightSearch } from "./useFlightsSearch";
import {
  useFlightSelectionPayloadContext,
  type FlightType,
} from "../../context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import {
  useFlightQuickSearchTokens,
  useFlightSearchTokens,
} from "../useFlightSearchTokens";
import { useFlightFiltersContext } from "../../context/FlightFiltersContext";
import type { FlightSearchPagedResultData } from "./types";
import { getOfferByIdFromSearchResult } from "./utils";

export const useSelectedReturnFlight = () => {
  const {
    selectedReturnFlightId,
    selectedOfferIndex,
    selectedFlightSearchSource,
  } = useFlightSelectionPayloadContext();
  const { query: tokensQuery } = useFlightSearchTokens({
    enabled: selectedFlightSearchSource === "full",
  });
  const quickTokensQuery = useFlightQuickSearchTokens();
  const { filters } = useFlightFiltersContext();

  const select = useCallback(
    (response: FlightSearchPagedResultData) => {
      const selectedOffer = getOfferByIdFromSearchResult(
        response,
        selectedOfferIndex,
      );
      if (!selectedOffer) throw new Error();

      const selectedReturnFlight = selectedOffer.flightsOverview.find(
        (fo) => fo.returnFlight?.key === selectedReturnFlightId,
      )?.returnFlight;

      return selectedReturnFlight;
    },
    [selectedReturnFlightId, selectedOfferIndex],
  );

  return useFlightSearch<FlightType | undefined>(
    selectedFlightSearchSource === "quick" ? quickTokensQuery : tokensQuery,
    filters,
    {
      select,
    },
  );
};
